import { ActionReducerMap, Action, ActionReducer } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import * as fromUser from './user.reducer';
import * as fromProfile from './profile.reducer';
import * as fromError from './error.reducer';
import * as fromAuth from './auth.reducer';
import * as fromDocument from './document.reducer';
import * as fromFilter from './filter.reducer';
import * as fromUpload from './upload.reducer';
import * as fromDownload from './download.reducer';
import * as fromConfig from './config.reducer';
import * as fromLoading from './loading.reducer';
import * as fromTranslation from './translation.reducer';

import * as userActions from '../actions/user.actions';

export interface AppState {
    router?: RouterReducerState;
    user: fromUser.State;
    profile: fromProfile.State;
    error: fromError.State;
    auth: fromAuth.State;
    document: fromDocument.State;
    filter: fromFilter.State;
    upload: fromUpload.State;
    download: fromDownload.State;
    config: fromConfig.State;
    loading: fromLoading.State;
    translation: fromTranslation.State;
}

export const reducers: ActionReducerMap<AppState> = {
    router: routerReducer,
    user: fromUser.reducer,
    profile: fromProfile.reducer,
    error: fromError.reducer,
    auth: fromAuth.reducer,
    document: fromDocument.reducer,
    filter: fromFilter.reducer,
    upload: fromUpload.reducer,
    download: fromDownload.reducer,
    config: fromConfig.reducer,
    loading: fromLoading.reducer,
    translation: fromTranslation.reducer
};

export function clearFilesMetaReducer(reducer: ActionReducer<any>) {
    return (state: AppState, action: Action) => {
        if (action.type === userActions.setIsAdmin.type) {
            const newState = { ...state };
            newState.document = undefined;
            newState.filter = undefined;
            newState.upload = undefined;
            newState.download = undefined;
            return reducer(newState, action);
        }
        return reducer(state, action);
    };
}
